/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Start_UploadInputs */

const cs_pm_start_upload = /** @type {(inputs: Pm_Start_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spárovat nahraný export`)
};

const en_pm_start_upload = /** @type {(inputs: Pm_Start_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match uploaded export`)
};

/**
* | output |
* | --- |
* | "Match uploaded export" |
*
* @param {Pm_Start_UploadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_start_upload = /** @type {((inputs?: Pm_Start_UploadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Start_UploadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_start_upload(inputs)
	return cs_pm_start_upload(inputs)
});